import { ORGANIZATION_TYPES, type OrganizationType } from '../constants/organization';

const organizationTypeSet = new Set<string>(Object.values(ORGANIZATION_TYPES));

export function isOrganizationType(value: string): value is OrganizationType {
  return organizationTypeSet.has(value);
}

export function toOrganizationType(value: string | null | undefined): OrganizationType | null {
  if (typeof value !== 'string' || !isOrganizationType(value)) return null;
  return value;
}
